import React from 'react';
import { Plane, Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_5112f21d-d025-4b4a-bf6b-cb6ce4d15052/artifacts/hq70snir_VBK%20LOGO.png" 
                alt="Vacay with K Logo" 
                className="h-12 w-12 object-contain"
              />
              <span className="text-2xl font-bold brand-title">Vacay with K</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner in creating unforgettable tropical experiences. Let us turn your travel dreams into reality.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              <a
                href="#"
                className="bg-white/10 hover:bg-[#ef571b] p-2 rounded-lg transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 hover:bg-[#ef571b] p-2 rounded-lg transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 hover:bg-[#ef571b] p-2 rounded-lg transition-colors duration-300"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 hover:bg-[#ef571b] p-2 rounded-lg transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('destinations')}
                  className="text-gray-400 hover:text-[#ef571b] transition-colors"
                >
                  Destinations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('packages')}
                  className="text-gray-400 hover:text-[#ef571b] transition-colors"
                >
                  Tour Packages
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-[#ef571b] transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-[#ef571b] transition-colors"
                >
                  Reviews
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-[#ef571b] transition-colors cursor-pointer">Custom Itineraries</li>
              <li className="hover:text-[#ef571b] transition-colors cursor-pointer">Hotel Bookings</li>
              <li className="hover:text-[#ef571b] transition-colors cursor-pointer">Flight Arrangements</li>
              <li className="hover:text-[#ef571b] transition-colors cursor-pointer">Travel Insurance</li>
              <li className="hover:text-[#ef571b] transition-colors cursor-pointer">24/7 Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-gray-400">
                <Mail className="h-5 w-5 text-[#ef571b] mt-0.5" />
                <div>
                  <p>info@vacaywithk.com</p>
                  <p>bookings@vacaywithk.com</p>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Phone className="h-5 w-5 text-[#ef571b] mt-0.5" />
                <div>
                  <p>+1 (555) 123-4567</p>
                  <p>+1 (555) 987-6543</p>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="h-5 w-5 text-[#ef571b] mt-0.5" />
                <div>
                  <p>123 Paradise Lane</p>
                  <p>Miami Beach, FL 33139</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Vacay with K. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-[#ef571b] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#ef571b] transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-[#ef571b] transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;